/**
 * Gmail OAuth token helpers.
 * Tokens are stored in localStorage per broker so each broker
 * only needs to connect their Gmail account once.
 */

function gmailKey(brokerName) {
  return `sterling_gmail_${(brokerName || '').replace(/\s+/g, '_')}`;
}

export function getGmailTokens(brokerName) {
  try { return JSON.parse(localStorage.getItem(gmailKey(brokerName))) || null; }
  catch { return null; }
}

export function setGmailTokens(brokerName, tokens) {
  localStorage.setItem(gmailKey(brokerName), JSON.stringify(tokens));
}

export function clearGmailTokens(brokerName) {
  localStorage.removeItem(gmailKey(brokerName));
}
